<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="A propos de nos formations" />
            <FormaTions />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import FormaTions from '../FormaTions/Formations.vue'


export default {
    name: 'FormationPage',
    components: {
        NavBar,
        PageTitle,
        FormaTions,
        FooterComp,
    }
}
</script>